import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { FaArrowRight } from 'react-icons/fa';
import '../../../assets/css/Buyer/aboutus/about.css';


const AboutDreams = ({
  title = "Turning your real estate dreams true!",
  description = "We help you find more than just a property — we help you find your dream lifestyle.",
  backgroundImage = "https://www.roberthalf.com/content/dam/roberthalf/images/blogs/us/en/hr1/the-value-of-teamwork-in-the-workplace-blog-RH-05-23-24.jpg.jpg",
  buttonText = "Get a Quote",
  features = [
    {
      number: "01",
      title: "Expert Local Knowledge",
      description: "With personalized service and expert guidance"
    },
    {
      number: "02",
      title: "Hassle-Free Transactions",
      description: ""
    },
    {
      number: "03",
      title: "Comprehensive Support",
      description: ""
    }
  ]
}) => {
  return (
    <section className="dreams-section section-padding">
      <div 
        className="dreams-bg" 
        style={{ backgroundImage: `url(${backgroundImage})` }}
      ></div>
      
      <Container className="position-relative h-100 d-flex align-items-center justify-content-end">
        <Card className="dreams-card p-4 shadow-lg border-0 animate-on-scroll fade-left">
          <Card.Body>
            <h2 className="fw-bold mb-3 dreams-title">{title}</h2>
            <p className="text-muted mb-4 dreams-description">{description}</p>
            
            <Button 
              variant="outline-dark" 
              className="dreams-button rounded-pill px-4 mb-4 d-flex align-items-center gap-2"
            >
              {buttonText} <FaArrowRight />
            </Button>

            <div className="feature-list">
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className={`feature-item py-3 ${index === 0 ? 'border-top' : ''} ${index === features.length - 1 ? 'border-bottom' : ''} border-top`}
                >
                  <span className="feature-number text-muted me-3">{feature.number}</span>
                  <div className="feature-content">
                    <h6 className="fw-bold mb-1 feature-title">{feature.title}</h6>
                    {feature.description && (
                      <small className="text-muted feature-desc">{feature.description}</small>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Card.Body>
        </Card>
      </Container>
    </section>
  );
};

export default AboutDreams;